import { queryOptions } from "@tanstack/react-query"

import { apiKey } from "@/lib/api/changes"
import { apiFetch } from "@/lib/api/client"
import type { Catalogue, InvolvementFamily } from "@/types/catalogue"

/** The roles a person can hold at a firm. Fixed per handbook edition. */
export const involvementTypeQueries = {
  families: () =>
    queryOptions({
      queryKey: apiKey("/involvement-types"),
      queryFn: async ({ signal }) =>
        await apiFetch<Catalogue<InvolvementFamily>>("/involvement-types", {
          anonymous: true,
          signal,
        }),
      staleTime: Number.POSITIVE_INFINITY,
    }),

  /** What an appointed representative can be put forward for, AR variants first. */
  nominatable: () =>
    queryOptions({
      queryKey: apiKey("/involvement-types", { nominatable: 1 }),
      queryFn: async ({ signal }) => {
        const { data } = await apiFetch<Catalogue<InvolvementFamily>>(
          "/involvement-types",
          { anonymous: true, params: { nominatable: 1 }, signal }
        )

        return data
      },
      staleTime: Number.POSITIVE_INFINITY,
    }),
}
